<template>
    <div class="ShortCourse">
        <div class="titlePage">Reporte de Cursos Cortos</div>
    </div>
</template>

<script>
export default {
  name: 'ShortCourse',
}
</script>